import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   OnChanges,
   OnInit,
   ViewEncapsulation,
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReportParameterFormFactoryService } from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form-factory.service';
import { Store } from '@ngrx/store';
import { interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DashboardTile } from 'src/app/pages/dashboard/models/dashboard-tile.model';
import { Tiles } from '../../containers/tile-wrapper/tile-component-accessor';
import { TileBase } from '../shared/tile-base';
import { RunPhoneQueues_runPhoneQueuesTile_data_queues } from './queries/generated/RunPhoneQueues';
import { PhoneQueuesParametersFormService } from './services/phone-queues-parameters-form.service';

@Component({
   encapsulation: ViewEncapsulation.None,
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'ndt-phone-queues-tile',
   styleUrls: ['./phone-queues-tile.component.scss'],
   templateUrl: './phone-queues-tile.component.html',
   host: {
      class: 'phone-queues-table-tile-wrapper',
   },
   standalone: false,
})
export class PhoneQueuesTileComponent
   extends TileBase<PhoneQueuesParametersFormService, any>
   implements OnInit, OnChanges
{
   phoneQueuesData: RunPhoneQueues_runPhoneQueuesTile_data_queues[] = [];

   columns = [
      'queueName',
      'queueNumber',
      'loggedInAgents',
      'callsWaiting',
      'callsAbandoned',
      'oldestCallWaiting',
      'oldestCall',
      'averageHoldLast30Minutes',
      'averageHoldToday',
   ];

   constructor(
      protected formServiceFactory: ReportParameterFormFactoryService,
      protected store: Store,
      public changeDetectorRef: ChangeDetectorRef,
      protected fb: UntypedFormBuilder,
      protected router: Router
   ) {
      super(formServiceFactory, store, changeDetectorRef, fb, router);
      this.formService = formServiceFactory.getService(Tiles.PhoneQueues);

      interval(100)
         .pipe(takeUntil(this.destroyed$))
         .subscribe(() => {
            this.refresh();
            this.changeDetectorRef.markForCheck();
         });
   }

   override ngOnInit(): void {
      super.ngOnInit();
      this.refresh();
   }

   ngOnChanges(): void {
      this.refresh();
   }

   onRefreshTile() {
      this.refresh();
      this.changeDetectorRef.markForCheck();
   }

   get rowHeight(): number {
      return this.getTileTableRowHeight(this.tileConfig);
   }

   private refresh(): void {
      this.phoneQueuesData = this.tileData?.data?.queues ?? [];
   }

   getRouterLink(extensionId: number): string {
      return `/extensions/${extensionId}`;
   }

   getTileTableRowHeight(tileConfig: DashboardTile | null): number {
      return (tileConfig?.dashboardTileLayoutConfiguration?.height ?? -1) <= 1 ? 25 : 35;
   }
}
